export type ActorType = "admin" | "salesAgent";

export const getActorTypeFromHost = (): ActorType => {
  const host = window.location.hostname;
  if (host.split(".").some((label) => label.startsWith("sale"))) {
    return "salesAgent";
  }
  return "admin";
};